import React from 'react'
import EcomSellerDashboard from '../EcomSellerDashboard'

const EcomproductView = () => {
  return (
    <div>
      <EcomSellerDashboard/>
      jjjj
    </div>
  )
}

export default EcomproductView
